import { NativeEventBridge } from "@ng-mw/shared-react-components"
import MenyNativeEvent from "@app/events/MenyNativeEvent"
import { SafeArea } from "@app/types"

export const connectNativeSafeArea = (onSafeArea: (safeArea: SafeArea) => void) => {
    // The first response can precede tab visibility. Continue receiving geometry
    // changes when tabs appear, hide, or resize after rotation.
    const listener = NativeEventBridge.listen(MenyNativeEvent.AppSafeArea, onSafeArea, false)
    NativeEventBridge.broadcastNative(MenyNativeEvent.ReadyForSafeArea)
    return () => NativeEventBridge.unlisten(listener)
}
